module.exports = __webpack_public_path__ + "img/unicaja-dark.9d06a6bd.png";